module.exports = __webpack_public_path__ + "static/awards-icon-7-d4aa5089af1980ecc1a6a204e4c5a784.png";